import { colors } from "src/colors/colors"

const IconNoCheck = (props) => {
  const {disabled} = props
  return (
    <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17 3.7c1.8 0 3.3 1.5 3.3 3.3v10c0 1.8-1.5 3.3-3.3 3.3H7c-1.8 0-3.3-1.5-3.3-3.3V7c0-1.8 1.5-3.3 3.3-3.3h10ZM17 2H7C4.2 2 2 4.2 2 7v10c0 2.8 2.2 5 5 5h10c2.8 0 5-2.2 5-5V7c0-2.8-2.2-5-5-5Z"
      fill={disabled ? "#D8D8DC" : "#D8D8DC"}
    />
  </svg>
  )
}

export default IconNoCheck

